import './MobileDeliveryMessage.scss';

import classnames from 'classnames';
import React from 'react';

import TRANSLATIONS from './translations@default.json';

export const CustomCatMobileDeliveryBlock = ({
	deliveryMessage,
	stockStatus,
	deals,
}) => {
	if (!deliveryMessage || stockStatus !== 'LiveProduct') {
		return null;
	}

	let deliveryMessageWithShortMonth = deliveryMessage;

	TRANSLATIONS.delivery.shortMonthNames.forEach(function ([long, short]) {
		if (deliveryMessage.includes(long)) {
			deliveryMessageWithShortMonth = deliveryMessage.replace(long, short);
		}
	});

	const DeliveryInfo = () => (
		<div className="product-card__delivery-information-item product-card__delivery-information-item--mobile px-2">
			<i className="ico ico-delivery text-xl text-ongreen mr-2 align-middle" />
			<div
				dangerouslySetInnerHTML={{
					__html: deliveryMessageWithShortMonth,
				}}
				className="text-water inline-block"
			/>
		</div>
	);

	return (
		<div
			className={classnames('text-center text-body-xs py-1 rounded mt-auto', {
				'product-card__delivery-message-block': !deals,
			})}>
			<DeliveryInfo />
		</div>
	);
};

export default CustomCatMobileDeliveryBlock;
